/* Steel Monkey: pre-checkout popup offering whichever of BLUD, SWET, TIERZ is missing from the cart. */
(function(){
  if(window.__smNudge)return;window.__smNudge=true;
  var KEY='smNudgeSeen',root=function(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';};
  var dlg,pendingForm=null,changed=false,busy=false,leaving=false;
  function seen(){try{return sessionStorage.getItem(KEY)==='1';}catch(e){return false;}}
  function markSeen(){try{sessionStorage.setItem(KEY,'1');}catch(e){}}
  function isCartPage(){return /\/cart\/?$/.test(location.pathname);}
  function variants(item){if(!item._v){try{item._v=JSON.parse(item.querySelector('[data-smn-variants]').textContent);}catch(e){item._v=[];}}return item._v;}
  function chosenId(item){var r=item.querySelector('.smn__var input:checked');if(r)return +r.value;var v=variants(item).filter(function(x){return x.available;})[0];return v&&v.id;}
  function planFor(item,planName){
    if(!planName)return null;
    var v=variants(item).filter(function(x){return x.id===chosenId(item);})[0];if(!v||!v.plans.length)return null;
    var m=v.plans.filter(function(p){return p.name===planName;})[0];
    if(!m){var d=(planName.match(/\d+/)||[])[0];if(d)m=v.plans.filter(function(p){return (p.name.match(/\d+/)||[])[0]===d;})[0];}
    return m||v.plans[0];
  }
  function paint(item){
    var v=variants(item).filter(function(x){return x.id===chosenId(item);})[0];if(!v)return;
    var p=planFor(item,dlg._plan),el=item.querySelector('[data-smn-price]');
    el.innerHTML=p?'<b>'+p.price+'</b><small>Subscribed, saving 10%</small>':'<b>'+v.price+'</b>';
  }
  function proceed(){
    var f=pendingForm;pendingForm=null;leaving=true;
    if(dlg&&dlg.open)dlg.close();
    if(f&&f.isConnected){var i=document.createElement('input');i.type='hidden';i.name='checkout';i.value='1';f.appendChild(i);HTMLFormElement.prototype.submit.call(f);}
    else location.href=root()+'checkout';
  }
  function open(missing,plan){
    dlg._plan=plan;changed=false;leaving=false;
    var items=[].slice.call(dlg.querySelectorAll('[data-smn-item]')),shown=0;
    items.forEach(function(it){
      var on=missing.indexOf(+it.dataset.productId)>-1;it.hidden=!on;
      var b=it.querySelector('[data-smn-add]');b.disabled=false;b.classList.remove('is-done');b.textContent='Add to cart';
      if(on){shown++;paint(it);}
    });
    if(!shown){proceed();return;}
    dlg.classList.toggle('smn--one',shown===1);
    var err=dlg.querySelector('[data-smn-err]');if(err)err.hidden=true;
    markSeen();
    dlg.showModal();
    var go=dlg.querySelector('[data-smn-go]');go&&go.focus({preventScroll:true});
  }
  function check(form,btn){
    if(busy)return;busy=true;btn&&btn.setAttribute('aria-busy','true');
    pendingForm=form;
    fetch(root()+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      busy=false;btn&&btn.removeAttribute('aria-busy');
      var inCart=(cart.items||[]).map(function(i){return i.product_id;});
      var plan=null;(cart.items||[]).some(function(i){if(i.selling_plan_allocation&&i.selling_plan_allocation.selling_plan){plan=i.selling_plan_allocation.selling_plan.name;return true;}});
      var missing=[].slice.call(dlg.querySelectorAll('[data-smn-item]')).map(function(it){return +it.dataset.productId;}).filter(function(id){return inCart.indexOf(id)<0;});
      if(!missing.length||!inCart.length){proceed();return;}
      open(missing,plan);
    }).catch(function(){busy=false;btn&&btn.removeAttribute('aria-busy');proceed();});
  }
  function onClick(e){
    var b=e.target.closest&&e.target.closest('button[name="checkout"],input[name="checkout"]');
    if(!b||!dlg||seen())return;
    var f=b.form||b.closest('form');
    e.preventDefault();e.stopImmediatePropagation();
    check(f,b);
  }
  function add(item){
    var b=item.querySelector('[data-smn-add]'),id=chosenId(item);if(!id||b.disabled)return;
    var it={id:id,quantity:1},p=planFor(item,dlg._plan);if(p)it.selling_plan=p.id;
    b.disabled=true;b.setAttribute('aria-busy','true');
    var err=dlg.querySelector('[data-smn-err]');if(err)err.hidden=true;
    fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[it]})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(){
        changed=true;b.removeAttribute('aria-busy');b.classList.add('is-done');b.textContent='Added';
      })
      .catch(function(e){b.disabled=false;b.removeAttribute('aria-busy');if(err){err.textContent=(e&&(e.description||e.message))||'Something went wrong. Please try again.';err.hidden=false;}});
  }
  function init(){
    dlg=document.getElementById('sm-checkout-nudge');if(!dlg)return;
    document.addEventListener('click',onClick,true);
    dlg.addEventListener('click',function(e){
      if(e.target===dlg){dlg.close();return;}
      if(e.target.closest('[data-smn-close]')){dlg.close();return;}
      if(e.target.closest('[data-smn-go]')){proceed();return;}
      var a=e.target.closest('[data-smn-add]');if(a)add(a.closest('[data-smn-item]'));
    });
    dlg.addEventListener('change',function(e){var it=e.target.closest('[data-smn-item]');if(it&&e.target.matches('.smn__var input'))paint(it);});
    dlg.addEventListener('close',function(){
      pendingForm=null;if(leaving||!changed)return;
      if(isCartPage()){location.reload();return;}
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      var d=document.querySelector('cart-drawer');if(d&&typeof d.show==='function')setTimeout(function(){d.show();},50);
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
